export default __webpack_public_path__ + "static/chris-benson-nKEARsgmrqc-unsplash-e76c8f461d15b50cbe66e52e13c58f0d.jpg";